import { gql } from '@apollo/client';

export const GET_TASK_NOTIFICATIONS = gql`
  query GET_TASK_NOTIFICATIONS($assigneeOnly: Boolean, $page: PageModelInput) {
    tasks(assigneeOnly: $assigneeOnly, page: $page) {
      totalCount
      tasks {
        uid
        name
        assignedDateTime
        targetPerson {
          fullName
        }
      }
    }
  }
`;
